import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson funda la empresa London Rubber Company y se dedica a la venta de preservativos importados y productos para barberías.',
		},
		{
			year: 1929,
			description: 'London Rubber Company (LRC) registra la marca Durex.',
		},
		{
			year: '1950s',
			description: 'Durex presenta su primer condón lubricado.',
		},
		{
			year: 1953,
			description: 'Durex es la primera marca en desarrollar y utilizar pruebas electrónicas.',
		},
		{
			year: '1960s',
			description: 'Durex presenta el primer preservativo con forma anatómica.',
		},
		{
			year: '1970s',
			description: 'Durex es la primera marca de condones del mundo en hacer publicidad en diferentes países.',
		},
		{
			year: '1990s',
			description: 'Durex es la primera marca de preservativos que adopta un sello de calidad global como estándar.',
		},
		{
			year: 1995,
			description: 'Durex introduce la gama de condones de colores y sabores.',
		},
		{
			year: 1996,
			description: 'Durex es la primera marca de preservativos que crea su propia página web.',
		},
		{
			year: 1997,
			description: 'Durex introduce los condones sin látex. Para el nuevo producto se utiliza un nuevo material hipoalergénico: el poliuretano sintético desarrollado por Durex. Es más suave y elástico que el látex de caucho natural.',
		},
		{
			year: 1998,
			description: 'Durex es la primera marca de condones en realizar y publicar una encuesta global sobre la salud sexual.',
		},
		{
			year: 2001,
			description: 'Durex introduce Pleasuremax. Con este preservativo, Durex se convierte en la primera marca de condones que lanza un producto que combina puntos y estrías para conseguir la máxima estimulación en la pareja.',
		},
		{
			year: 2003,
			description: 'Durex presenta una nueva y emocionante gama de lubricantes Play.',
		},
		{
			year: 2005,
			description: 'La red Durex lanza los informes «The Face of Global Sex» que estudian los aspectos del comportamiento sexual de las personas. Se crearon para informar, principalmente, a académicos e instituciones públicas.',
		},
		{
			year: 2008,
			description: 'Para promover el sexo seguro entre la gente joven, Durex anima a los jóvenes de entre los 16 y los 25 años a diseñar un póster original sobre la salud sexual. Un póster diseñado por y para ellos.',
		},
		{
			year: 2010,
			description: '¡Durex cumple 80 años!',
		},
		{
			year: 2010,
			description: 'La multinacional Reckitt Benckiser adquiere la marca Durex.',
		},
		{
			year: 2010,
			description: 'Durex presenta Performax Intense, un preservativo diseñado para un placer más duradero. Con una capa interna que contiene 5% de benzocaína y una estructura muy estimulante, ayuda a tener relaciones más largas e intensas.',
		},
		{
			year: 2019,
			description: '¡Durex cumple 90 años!',
		},
		{
			year: 2022,
			description: 'Durex lanza su nueva identidad de marca.',
		},
	]
}